import React from "react";
import "./Machinery.scss";
// import AOS from "aos";
import "aos/dist/aos.css";

const Machinery = () => {

  return (
    <div className="machinery">
      <div className="machinery__heading" data-aos="fade-up">
        Hi
      </div> 
    </div>
  );
};

export default Machinery;
